import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Platform_iOS_instance = new (Platform())('iOS', 0);
  Platform_Android_instance = new (Platform())('Android', 1);
  Platform_Web_instance = new (Platform())('Web', 2);
  Platform_Desktop_instance = new (Platform())('Desktop', 3);
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var Platform_iOS_instance;
var Platform_Android_instance;
var Platform_Web_instance;
var Platform_Desktop_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var PlatformClass;
function Platform() {
  if (PlatformClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Platform');
    PlatformClass = $;
  }
  return PlatformClass;
}
function Platform_Web_getInstance() {
  static_init();
  return Platform_Web_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  Platform_Web_getInstance as Platform_Web_getInstance2840w5bkfolz8,
  Companion_instance_0 as Companion_instance1lm8x0jadqh2g,
};
//endregion

//# sourceMappingURL=Platform.mjs.map
